// src/components/ThemeToggle.jsx
import { useTheme } from "../hooks/useTheme";
import { Ic } from "./Icons";
import { ICONS } from "./iconsData";

/**
 * Переключатель светлой/тёмной темы. Живёт в тулбаре MainLayout.
 *
 * Использует .icon-btn - тот же визуальный слой, что у колокольчика,
 * кнопок навигации и меню «⋯». Отдельного класса не заводим: тема -
 * это «действие над интерфейсом», а не отдельная сущность.
 */
export function ThemeToggle() {
  const { isDark, toggle } = useTheme();
  return (
    <button
      type="button"
      className="icon-btn"
      onClick={toggle}
      title={isDark ? "Светлая тема" : "Тёмная тема"}
      aria-label={isDark ? "Включить светлую тему" : "Включить тёмную тему"}
      aria-pressed={isDark}
    >
      <Ic d={isDark ? ICONS.sun : ICONS.moon} size={17} />
    </button>
  );
}

export default ThemeToggle;
